// extracted by mini-css-extract-plugin
export var blue = "_20-g";
export var brand = "_20-c";
export var darkGrey = "_20-f";
export var disabled = "_20-6";
export var disabledSubtle = "_20-7";
export var error = "_20-8";
export var green = "_20-h";
export var grey = "_20-e";
export var icon = "_20-0";
export var inherit = "_20-b";
export var lightGrey = "_20-d";
export var orange = "_20-j";
export var pink = "_20-l";
export var primary = "_20-1";
export var purple = "_20-m";
export var quaternary = "_20-4";
export var quinary = "_20-5";
export var red = "_20-k";
export var secondary = "_20-2";
export var success = "_20-a";
export var tertiary = "_20-3";
export var warning = "_20-9";
export var white = "_20-n";
export var yellow = "_20-i";